export * from '@fhs/routing/src/routes/(auth)/confirm-jwt';
export { default } from '@fhs/routing/src/routes/(auth)/confirm-jwt';
